<template>
  <div style="display: none" />
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth.store';
import { storeToRefs } from 'pinia';
import { onMounted, watch } from 'vue';

const SPEED = 0.4;
// const SPEED = 0.05;
const DEV_FPS = 2 / 1;
const PROD_FPS = 1 / 1;
const FPS = import.meta.env.VITE_ENV === 'development' ? DEV_FPS : PROD_FPS;
const SPEED_OVER_FPS = SPEED / FPS;

let internalAngle = Math.floor(Math.random() * 360);
let angle = Math.floor(Math.random() * 360);

function setHue(hueAngle: number) {
  document.documentElement.style.setProperty('--hue', hueAngle.toString());
  document.documentElement.style.setProperty('--hue-2', (hueAngle + 5).toString());
  document.documentElement.style.setProperty('--hue-3', (hueAngle + 10).toString());
  document.documentElement.style.setProperty('--hue-angle', `${hueAngle}deg`);
}

function cycleColors() {
  internalAngle = internalAngle - SPEED_OVER_FPS;
  angle = Math.sin(internalAngle / 10) * 180 - 32;
  setHue(angle);
}

function applyFixedHue(hue: number) {
  if (window.colorCycleInterval) {
    clearInterval(window.colorCycleInterval);
    window.colorCycleInterval = undefined as any;
  }
  setHue(hue);
}

function startCycling() {
  if (window.colorCycleInterval) clearInterval(window.colorCycleInterval);
  window.colorCycleInterval = setInterval(cycleColors, Math.floor(1000 / FPS)) as any as number;
  cycleColors();
}

const authStore = useAuthStore();
const { userDetails } = storeToRefs(authStore);

watch(
  () => userDetails.value?.accentHue,
  (accentHue) => {
    if (window.isVisualTest || import.meta.env.VITE_DEV_DISABLE_HUE_UPDATE === 'true') return;

    if (accentHue !== null && accentHue !== undefined) {
      applyFixedHue(accentHue);
    } else {
      startCycling();
    }
  },
);

onMounted(() => {
  const devDisableHueUpdate = import.meta.env.VITE_DEV_DISABLE_HUE_UPDATE;
  if (window.isVisualTest || devDisableHueUpdate === 'true') {
    angle = 192 - 32;
    cycleColors();
    return;
  }

  const accentHue = userDetails.value?.accentHue;
  if (accentHue !== null && accentHue !== undefined) {
    applyFixedHue(accentHue);
  } else {
    startCycling();
  }
});
</script>

<style lang="css">
:root {
  --hue-angle: 0deg;
}
</style>
